import { platformConfig } from '../../../constants/platform'
import { shortMonth } from '../../../constants/shortMonth'
import { formatMessage } from '../../../constants/strings/intl/intlHooks'
import { messages } from '../../../constants/strings/messages'
import { BRIO_SAC_WHATSAPP_NUMBER, WHATSAPP_WEB_URL } from '../../../constants/whatsAppInfo'
import { ifMoneyInt } from '../../../utils/formatters'
import { openWhatsApp } from '../../../utils/openWhatsApp'
import { openWhatsAppWeb } from '../../../utils/openWhatsAppWeb'

interface OnPressSACInput {
  installmentId: number
  dueDate: string
  originalValue: number
  currentBalance: number
  conditionDescription: string | null
}

export const onPressSAC = async (input: OnPressSACInput[], showConfirmationDialog?: boolean = false) => {
  const termInDays = 2
  const actualDate = new Date()
  actualDate.setDate(actualDate.getDate() + termInDays)
  const newDueDate = `${actualDate.getDay()}/${actualDate.getMonth()}/${actualDate.getFullYear()}`

  let whatsAppText = formatMessage(messages.financeFutureScreen_whatsApp_message)
  input.forEach(message => {
    const value = ifMoneyInt(message.currentBalance)
    const description = message.conditionDescription || ''
    const date = formatDate(new Date(message.dueDate))
    const messageComplete = `${value}\n${description} ${date}\n${newDueDate}\n`

    whatsAppText += messageComplete
  })
  platformConfig.isWeb()
    ? openWhatsAppWeb({ url: WHATSAPP_WEB_URL, text: whatsAppText })
    : openWhatsApp(whatsAppText, BRIO_SAC_WHATSAPP_NUMBER)
}

const formatDate = (dueDate: Date) => shortMonth[dueDate.getMonth()].toUpperCase() + ' ' + dueDate.getFullYear()
